import personsTypes from '../persons/types';
import types from '../filter/types';
import locationsTypes from '../locations/types';

const defaultState = {
  filteredSuggestions: [],
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case personsTypes.GET_PERSON_AUTOCOMPLETE_LIST:
      return { ...state, isLoading: true };
    case personsTypes.GET_PERSON_AUTOCOMPLETE_LIST_SUCCESS:
      return { ...state, filteredSuggestions: data, isLoading: false };
    case personsTypes.GET_PERSON_AUTOCOMPLETE_LIST_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_AUTO_COMPLETE_SUGGESTIONS:
      return { ...state, isLoading: true };
    case types.GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS:
      return { ...state, filteredSuggestions: data, isLoading: false };
    case types.GET_AUTO_COMPLETE_SUGGESTIONS_FAILURE:
      return { ...state, isLoading: false };

    case locationsTypes.GET_LOCATION_AUTOCOMPLETE_SUGGESTIONS:
      return { ...state, isLoading: true };
    case locationsTypes.GET_LOCATION_AUTOCOMPLETE_SUGGESTIONS_SUCCESS:
      return { ...state, filteredSuggestions: data, isLoading: false };
    case locationsTypes.GET_LOCATION_AUTOCOMPLETE_SUGGESTIONS_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
